import React from 'react';
import { FiInstagram, FiTwitter, FiYoutube, FiArrowUpRight, FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-[#050505] pt-32 pb-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-16 mb-24">
          <div className="lg:col-span-5">
            <a href="#" className="flex items-center gap-3 mb-10">
              <div className="w-12 h-12 bg-signal flex items-center justify-center rounded-sm">
                <span className="text-white font-black text-3xl">B</span>
              </div>
              <div className="flex flex-col leading-none">
                <span className="text-white font-black text-2xl tracking-tighter uppercase">BikeBloom</span>
                <span className="text-[11px] text-gray-500 tracking-[0.4em] font-bold uppercase">Urban Systems</span>
              </div>
            </a>
            <p className="text-gray-500 text-lg max-w-md leading-relaxed mb-10">
              We engineer equipment for the uncompromising commuter. Every weld, every chip, and every lumen is tested against the chaos of the city.
            </p>
            <div className="flex gap-4">
              {[FiInstagram, FiTwitter, FiYoutube].map((Icon, i) => (
                <a key={i} href="#" className="w-12 h-12 border border-white/10 flex items-center justify-center text-gray-400 hover:text-signal hover:border-signal transition-all">
                  <SafeIcon icon={Icon} className="text-xl" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-white font-black uppercase tracking-[0.2em] text-xs mb-8">System</h4>
            <ul className="space-y-4">
              {['Inventory', 'Security', 'Lighting', 'Cargo', 'Kits'].map(link => (
                <li key={link}><a href="#" className="text-gray-500 hover:text-white text-sm font-bold uppercase tracking-widest transition-colors flex items-center gap-2 group">
                  {link} <SafeIcon icon={FiArrowUpRight} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                </a></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-white font-black uppercase tracking-[0.2em] text-xs mb-8">Support</h4>
            <ul className="space-y-4">
              {['Help Center', 'Tracking', 'Warranty', 'Theft Protection', 'Returns'].map(link => (
                <li key={link}><a href="#" className="text-gray-500 hover:text-white text-sm font-bold uppercase tracking-widest transition-colors flex items-center gap-2 group">
                  {link} <SafeIcon icon={FiArrowUpRight} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                </a></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-white font-black uppercase tracking-[0.2em] text-xs mb-8">Transmission</h4>
            <p className="text-gray-500 text-sm mb-6 font-medium">Join the network for firmware updates and tactical drops.</p>
            <form className="relative">
              <input 
                type="email" 
                placeholder="OPERATIVE EMAIL" 
                className="w-full bg-white/5 border-b border-white/10 text-white px-0 py-4 text-xs font-black tracking-widest focus:outline-none focus:border-signal uppercase placeholder:text-gray-700"
              />
              <button type="submit" className="absolute right-0 top-1/2 -translate-y-1/2 text-signal hover:text-white transition-colors">
                <SafeIcon icon={FiArrowRight} className="text-xl" />
              </button>
            </form>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-12 border-t border-white/5 gap-8">
          <div className="flex items-center gap-4">
            <div className="w-2 h-2 bg-signal animate-pulse rounded-full"></div>
            <p className="text-[10px] font-black uppercase tracking-[0.3em] text-gray-600">All Systems Operational</p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-8 text-[10px] font-black uppercase tracking-[0.2em] text-gray-500">
            <a href="#" className="hover:text-white transition-colors">Privacy Protocol</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Engagement</a>
            <span className="text-gray-700 border-l border-white/10 pl-8 hidden md:block" style={{ textTransform: 'none' }}>
              Made by <a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white transition-colors">DigLab.ai</a> and <a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white transition-colors">LingLinkAI.cn</a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;